import React from 'react';
import { cn } from '../utils/cn';

/**
 * Divider Component - Atom
 * 
 * @param {Object} props
 * @param {string} props.orientation - 'horizontal' | 'vertical'
 * @param {string} props.variant - 'solid' | 'dashed' | 'dotted'
 */
const Divider = ({
  orientation = 'horizontal',
  variant = 'solid',
  className = '',
  children,
  ...props
}) => {
  const baseStyles = 'border-primary-200 dark:border-primary-700';

  const orientations = {
    horizontal: 'w-full border-t',
    vertical: 'h-full border-l',
  };

  const variants = {
    solid: 'border-solid',
    dashed: 'border-dashed',
    dotted: 'border-dotted',
  };

  if (children) {
    return (
      <div
        className={cn(
          'flex items-center',
          orientation === 'horizontal' ? 'w-full' : 'h-full flex-col',
          className
        )}
        {...props}
      >
        <div
          className={cn(
            'flex-1',
            orientations[orientation],
            variants[variant],
            baseStyles
          )}
        />
        <span className="px-4 text-sm text-primary-500 dark:text-primary-400">
          {children}
        </span>
        <div
          className={cn(
            'flex-1',
            orientations[orientation],
            variants[variant],
            baseStyles
          )}
        />
      </div>
    );
  }

  return (
    <div
      className={cn(
        orientations[orientation],
        variants[variant],
        baseStyles,
        className
      )}
      {...props}
      role="separator"
      aria-orientation={orientation}
    />
  );
};

export default Divider;
